<div class="container-fluid">
    <app-custom-table-title icon="support_agent" title="Soporte"
        subTitle="Consulta tus incidencias y abre nuevas con el equipo de Handly"
        [actions]="[{ label: 'Nueva incidencia', icon: 'add', onClick: newTicket.bind(this) }]">
    </app-custom-table-title>

    <div class="mt-4 mb-4 cf-table-card sp-card">
        <div class="sp-toolbar">
            <div class="sp-tabs" role="tablist">
                <button type="button" role="tab" class="sp-tab" *ngFor="let f of filters"
                    [class.sp-tab--active]="filter === f.value" [attr.aria-selected]="filter === f.value"
                    (click)="filter = f.value">
                    {{ f.label }}
                    <span class="sp-tab__count" *ngIf="f.value === 'open'">{{ openCount }}</span>
                    <span class="sp-tab__count" *ngIf="f.value === 'resolved'">{{ resolvedCount }}</span>
                    <span class="sp-tab__count" *ngIf="f.value === 'all'">{{ tickets.length }}</span>
                </button>
            </div>

            <div class="sp-search">
                <mat-icon>search</mat-icon>
                <input type="text" [(ngModel)]="search" placeholder="Buscar por asunto, módulo{{ isAdmin ? ' o usuario' : '' }}…" aria-label="Buscar incidencias" />
            </div>
        </div>

        <app-loading-state *ngIf="loading" message="Cargando incidencias…"></app-loading-state>

        <div class="sp-empty" *ngIf="!loading && loadError">
            <mat-icon>error_outline</mat-icon>
            <p>No se han podido cargar las incidencias.</p>
            <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="load()"><mat-icon>refresh</mat-icon> Reintentar</button>
        </div>

        <ng-container *ngIf="!loading && !loadError">
            <div class="sp-empty" *ngIf="visibleTickets.length === 0">
                <mat-icon>{{ search ? 'search' : (filter === 'open' ? 'done_all' : 'inbox') }}</mat-icon>
                <p *ngIf="search">No hay incidencias que coincidan con «{{ search }}».</p>
                <p *ngIf="!search && filter === 'open'">No tienes incidencias abiertas. ¿Necesitas ayuda? Abre una nueva.</p>
                <p *ngIf="!search && filter !== 'open'">Todavía no hay incidencias aquí.</p>
            </div>

            <ul class="sp-list" *ngIf="visibleTickets.length > 0">
                <li class="sp-row" *ngFor="let t of visibleTickets; trackBy: trackById" (click)="viewTicket(t)">
                    <span class="sp-priority" [ngClass]="'sp-priority--' + priority(t.priority).className"
                        [title]="'Prioridad ' + priority(t.priority).label"></span>

                    <div class="sp-row__main">
                        <div class="sp-row__subject">{{ t.subject }}</div>
                        <div class="sp-row__meta">
                            <span class="sp-tag">{{ t.category }}</span>
                            <span class="sp-row__priority">Prioridad {{ priority(t.priority).label | lowercase }}</span>
                            <span *ngIf="isAdmin" class="sp-row__user"><mat-icon>person</mat-icon>{{ t.name }}</span>
                        </div>
                    </div>

                    <div class="sp-row__side">
                        <span class="sp-status" [class.sp-status--resolved]="t.resolved">
                            <mat-icon>{{ t.resolved ? 'check_circle' : 'schedule' }}</mat-icon>
                            {{ t.resolved ? 'Resuelta' : 'Abierta' }}
                        </span>
                        <span class="sp-row__date">{{ t.date | date:'dd/MM/yyyy · HH:mm' }}</span>
                    </div>

                    <div class="sp-row__actions" (click)="$event.stopPropagation()">
                        <button mat-stroked-button class="sp-btn" (click)="viewTicket(t)">
                            <mat-icon>forum</mat-icon> Ver
                        </button>
                        <button *ngIf="isAdmin && !t.resolved" mat-stroked-button class="sp-btn sp-btn--resolve"
                            [disabled]="resolvingId === t.id" (click)="resolveTicket(t)">
                            <mat-icon>done_all</mat-icon> Resolver
                        </button>
                    </div>
                </li>
            </ul>
        </ng-container>
    </div>
</div>
